import request from '@/utils/request'
import { findMenuNodeInTree } from '@/utils/menuNavTree'
import { menuDisplayTitle } from '@/utils/menuDisplay'

function menuListFromStore (store) {
  if (store && store.state && store.state.common && Array.isArray(store.state.common.menuList)) {
    if (store.state.common.menuList.length) return store.state.common.menuList
  }
  try {
    return JSON.parse(sessionStorage.getItem('menuList') || '[]')
  } catch (e) {
    return []
  }
}

function dynamicMenuRoutesFromSession () {
  try {
    return JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
  } catch (e) {
    return []
  }
}

function pickMetaFromMatched (route) {
  const matched = (route && route.matched) || []
  let menuId = ''
  let pageTitle = ''
  for (let i = matched.length - 1; i >= 0; i--) {
    const meta = (matched[i] && matched[i].meta) || {}
    if (!menuId && meta.menuId != null) menuId = String(meta.menuId)
    if (!menuId && meta.id != null) menuId = String(meta.id)
    if (!pageTitle && typeof meta.title === 'string' && meta.title.trim()) {
      pageTitle = meta.title.trim()
    }
    if (menuId && pageTitle) break
  }
  return { menuId, pageTitle }
}

function pickFromActiveTab (store, route) {
  if (!store || !store.state || !store.state.common) {
    return { menuId: '', pageTitle: '' }
  }
  const common = store.state.common
  const routeName = route && route.name
  const activeName = common.mainTabsActiveName || routeName
  const tabs = common.mainTabs || []
  let tab = tabs.find(t => t && t.name === routeName)
  if (!tab && activeName) tab = tabs.find(t => t && t.name === activeName)
  if (!tab) {
    return { menuId: '', pageTitle: '' }
  }
  return {
    menuId: tab.menuId != null ? String(tab.menuId) : '',
    pageTitle: tab.title != null ? String(tab.title).trim() : ''
  }
}

function resolveMenuIdFromDynamicRoutes (route) {
  const routeName = route && route.name
  if (!routeName) return ''
  const hit = dynamicMenuRoutesFromSession().find(r => r && r.name === routeName)
  if (hit && hit.meta && hit.meta.menuId != null) return String(hit.meta.menuId)
  return ''
}

function translateRouteLabel (vm, keyOrName) {
  if (!vm || !keyOrName) return ''
  const raw = String(keyOrName).trim()
  if (!raw) return ''
  const keys = [`route.${raw}`]
  if (raw.indexOf('route.') !== 0) keys.push(`route.${raw}`)
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    if (vm.$te && vm.$te(k)) {
      const tr = vm.$t(k)
      if (tr && tr !== k) return String(tr).trim()
    }
  }
  if (/[\u4e00-\u9fff]/.test(raw)) return raw
  return ''
}

function resolvePageTitle (vm, store, menuId, titleCandidates, routeName) {
  const list = menuListFromStore(store)
  if (menuId && list.length) {
    const node = findMenuNodeInTree(list, menuId)
    if (node) {
      const fromMenu = vm ? menuDisplayTitle(vm, node) : (node.name || node.enName || '')
      if (fromMenu) return String(fromMenu).trim()
    }
  }
  const names = (titleCandidates || []).concat(routeName ? [routeName] : [])
  for (let i = 0; i < names.length; i++) {
    const translated = translateRouteLabel(vm, names[i])
    if (translated) return translated
  }
  return ''
}

export function buildOperatorPageContext (route, surface, store, vm) {
  if (!route) {
    return { surface: surface || 'soc_admin' }
  }

  const fromMatched = pickMetaFromMatched(route)
  const fromTab = pickFromActiveTab(store, route)
  const queryMenuId = route.query && route.query.menuId != null
    ? String(route.query.menuId).trim()
    : ''

  let menuId = queryMenuId || fromMatched.menuId || fromTab.menuId || resolveMenuIdFromDynamicRoutes(route)

  if (!menuId && store && store.state && store.state.common.menuActiveName) {
    const active = String(store.state.common.menuActiveName).trim()
    if (active && active !== 'home' && /^\d+$/.test(active)) menuId = active
  }

  const meta = route.meta || {}
  if (!menuId && meta.menuId != null) menuId = String(meta.menuId)
  if (!menuId && meta.id != null) menuId = String(meta.id)

  const pageTitle = resolvePageTitle(
    vm,
    store,
    menuId,
    [fromMatched.pageTitle, fromTab.pageTitle, meta.title],
    route.name
  )

  return {
    routePath: route.fullPath || route.path || '',
    routeName: route.name || '',
    menuId: menuId || '',
    pageTitle: pageTitle || '',
    surface: surface || 'soc_admin'
  }
}

export function fetchOperatorSupportTopics (pageContext) {
  return request({
    url: '/coffee/leo/training/operator-support/topics',
    method: 'get',
    params: pageContext || {}
  })
}

export function askOperatorSupport (data) {
  return request({
    url: '/coffee/leo/training/operator-support/ask',
    method: 'post',
    data
  })
}

export function recordOperatorPageView (pageContext) {
  return request({
    url: '/coffee/leo/training/operator-support/page-view',
    method: 'post',
    data: { pageContext: pageContext || {} }
  })
}

export function feedbackOperatorSupport (data) {
  return request({
    url: '/coffee/leo/training/operator-support/feedback',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/api/leoTrainingOperatorSupport.js